import React from 'react';
import { MenuItem } from '@mui/material';
import ToolbarMenuItem from 'features/toolbar/ToolbarMenuItem/ToolbarMenuItem';
import { useRecordingControl } from 'features/toolbar/toolbar/controls/recording/useRecordingControl';
import { RecordingIcon } from 'features/toolbar/toolbar/controls/recording/RecordingIcon';
import { ToolbarMenuItemWrapperProps } from 'features/toolbar/types';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from 'store/hooks';
import { openModal } from 'features/modal/modalSlice';

const RecordingControl = ({ onClick }: ToolbarMenuItemWrapperProps) => {
  const { t } = useTranslation('room');
  const dispatch = useAppDispatch();
  const {
    recorderStatus,
    icon,
    label,
    toggleRecording,
    active,
    isFeatureAvailable,
    bookmarksAvailable,
  } = useRecordingControl();

  if (!isFeatureAvailable) {
    return null;
  }

  const recordingStarted = recorderStatus === 'started';

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onClick?.(event);
    toggleRecording();
  };

  const handleAddBookmark = () => {
    dispatch(openModal('addBookmarkModal'));
  };

  const handleStopRecording = () => {
    toggleRecording();
  };

  if (bookmarksAvailable && recordingStarted) {
    return (
      <ToolbarMenuItem
        menu
        ariaLabel={label}
        icon={<RecordingIcon name={icon} active={active} />}
        MenuProps={{
          PopperProps: {
            sx: {
              zIndex: (theme) => theme.zIndex.tooltip,
            },
          },
        }}
        id="recording-control"
      >
        <MenuItem onClick={handleAddBookmark}>
          {t('toolbar.recording.menu_options.add_bookmark')}
        </MenuItem>
        <MenuItem onClick={handleStopRecording}>
          {t('toolbar.recording.menu_options.stop_recording')}
        </MenuItem>
      </ToolbarMenuItem>
    );
  }

  return (
    <ToolbarMenuItem
      id="recording-control"
      overlay={label}
      ariaLabel={label}
      disabled={recorderStatus === 'starting'}
      icon={<RecordingIcon name={icon} active={active} disabled={recorderStatus === 'starting'} />}
      onClick={handleClick}
    />
  );
};

export default RecordingControl;
